import { FaBullhorn, FaPlus, FaThumbtack, FaClock } from "react-icons/fa";
import { useState } from "react";

export default function Noticeboard() {
  const [notices, setNotices] = useState([
    {
      id: 1,
      title: "Staff Appreciation Event - Save the Date!",
      content: "Mark your calendars! Our annual staff appreciation event will be held on March 22, 2025. More details to follow. We're planning an exciting program with food, entertainment, and recognition of outstanding staff contributions.",
      author: "Emily Rodriguez",
      date: "2025-01-16",
      category: "Event",
      pinned: true,
      priority: "high",
    },
    {
      id: 2,
      title: "New Remote Work Policy Proposal",
      content: "The council is reviewing a proposed update to the remote work policy. Members are encouraged to review the draft document and provide feedback before the next meeting. The proposal includes flexible scheduling options and guidelines for hybrid work arrangements.",
      author: "Michael Chen",
      date: "2025-01-15",
      category: "Policy",
      pinned: true,
      priority: "medium",
    },
    {
      id: 3,
      title: "Budget Allocation Approved",
      content: "The Q1 2025 budget allocation has been approved by council vote. Funds will be distributed to departments according to the approved plan. Special emphasis has been placed on professional development and wellness programs.",
      author: "David Kim",
      date: "2025-01-15",
      category: "Announcement",
      pinned: false,
      priority: "medium",
    },
    {
      id: 4,
      title: "Wellness Program Survey Results",
      content: "Thank you to everyone who participated in the wellness program survey! We received 78 responses with valuable feedback. The wellness committee will be reviewing results and implementing improvements based on your suggestions. Stay tuned for updates!",
      author: "Lisa Anderson",
      date: "2025-01-12",
      category: "Update",
      pinned: false,
      priority: "low",
    },
    {
      id: 5,
      title: "Committee Chair Elections Complete",
      content: "Congratulations to our newly elected committee chairs! Events Chair: Maria Garcia, Communications Chair: James Wilson, Wellness Chair: Lisa Anderson. We look forward to your leadership and contributions to the council.",
      author: "Sarah Johnson",
      date: "2025-01-10",
      category: "Announcement",
      pinned: false,
      priority: "low",
    },
  ]);

  const [selectedCategory, setSelectedCategory] = useState("All");

  const categories = ["All", "Event", "Policy", "Announcement", "Update"];

  const getPriorityColor = (priority) => {
    switch (priority) {
      case "high":
        return { bg: "#fee", border: "#feb2b2", color: "#c53030" };
      case "medium":
        return { bg: "#fef5e7", border: "#fbd38d", color: "#d97706" };
      case "low":
        return { bg: "#e6f7ff", border: "#91d5ff", color: "#1890ff" };
      default:
        return { bg: "#f7fafc", border: "#e2e8f0", color: "#718096" };
    }
  };

  const filteredNotices =
    selectedCategory === "All"
      ? notices
      : notices.filter((notice) => notice.category === selectedCategory);

  const pinnedNotices = filteredNotices.filter((n) => n.pinned);
  const regularNotices = filteredNotices.filter((n) => !n.pinned);

  const NoticeCard = ({ notice }) => {
    const priorityStyle = getPriorityColor(notice.priority);

    return (
      <div
        style={{
          background: "white",
          borderRadius: "12px",
          padding: "24px",
          boxShadow: "0 2px 4px rgba(0, 0, 0, 0.08)",
          border: `2px solid ${notice.pinned ? "#667eea" : "#e2e8f0"}`,
          marginBottom: "16px",
          position: "relative",
        }}
      >
        {notice.pinned && (
          <div
            style={{
              position: "absolute",
              top: "-10px",
              right: "20px",
              background: "#667eea",
              color: "white",
              padding: "4px 12px",
              borderRadius: "12px",
              fontSize: "12px",
              fontWeight: "600",
              display: "flex",
              alignItems: "center",
              gap: "6px",
            }}
          >
            <FaThumbtack />
            PINNED
          </div>
        )}

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "start",
            marginBottom: "12px",
          }}
        >
          <h3
            style={{
              fontSize: "20px",
              fontWeight: "600",
              color: "#2d3748",
              margin: 0,
              paddingRight: "20px",
            }}
          >
            {notice.title}
          </h3>
          <span
            style={{
              padding: "4px 10px",
              borderRadius: "6px",
              fontSize: "12px",
              fontWeight: "600",
              background: priorityStyle.bg,
              color: priorityStyle.color,
              border: `1px solid ${priorityStyle.border}`,
              textTransform: "uppercase",
              flexShrink: 0,
            }}
          >
            {notice.priority}
          </span>
        </div>

        <p
          style={{
            color: "#4a5568",
            fontSize: "15px",
            lineHeight: "1.7",
            marginBottom: "16px",
          }}
        >
          {notice.content}
        </p>

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            paddingTop: "16px",
            borderTop: "1px solid #f7fafc",
          }}
        >
          <div
            style={{
              display: "flex",
              gap: "16px",
              fontSize: "13px",
              color: "#718096",
            }}
          >
            <div>
              <strong>Posted by:</strong> {notice.author}
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
              <FaClock />
              {new Date(notice.date).toLocaleDateString("en-US", {
                month: "long",
                day: "numeric",
                year: "numeric",
              })}
            </div>
          </div>
          <span
            style={{
              padding: "4px 10px",
              background: "#f7fafc",
              border: "1px solid #e2e8f0",
              borderRadius: "6px",
              fontSize: "12px",
              color: "#4a5568",
            }}
          >
            {notice.category}
          </span>
        </div>
      </div>
    );
  };

  return (
    <div
      style={{
        padding: "40px",
        maxWidth: "1200px",
        margin: "0 auto",
      }}
    >
      {/* Header */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "30px",
        }}
      >
        <div>
          <h1
            style={{
              fontSize: "32px",
              fontWeight: "700",
              color: "#2d3748",
              marginBottom: "8px",
            }}
          >
            Noticeboard
          </h1>
          <p style={{ color: "#718096", fontSize: "16px" }}>
            Stay updated with council announcements and news
          </p>
        </div>
        <button
          style={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
            color: "white",
            border: "none",
            padding: "12px 24px",
            borderRadius: "8px",
            fontSize: "15px",
            fontWeight: "500",
            cursor: "pointer",
            boxShadow: "0 4px 6px rgba(102, 126, 234, 0.3)",
          }}
        >
          <FaPlus />
          Post Notice
        </button>
      </div>

      {/* Category Filter */}
      <div
        style={{
          display: "flex",
          gap: "10px",
          marginBottom: "30px",
          padding: "16px",
          background: "white",
          borderRadius: "12px",
          boxShadow: "0 2px 4px rgba(0, 0, 0, 0.08)",
          border: "1px solid #e2e8f0",
          flexWrap: "wrap",
        }}
      >
        {categories.map((category) => (
          <button
            key={category}
            onClick={() => setSelectedCategory(category)}
            style={{
              padding: "8px 16px",
              background: selectedCategory === category ? "#667eea" : "#f7fafc",
              color: selectedCategory === category ? "white" : "#4a5568",
              border: "1px solid",
              borderColor: selectedCategory === category ? "#667eea" : "#e2e8f0",
              borderRadius: "8px",
              cursor: "pointer",
              fontSize: "14px",
              fontWeight: selectedCategory === category ? "600" : "400",
              transition: "all 0.2s",
            }}
          >
            {category}
          </button>
        ))}
      </div>

      {/* Pinned Notices */}
      {pinnedNotices.length > 0 && (
        <div style={{ marginBottom: "30px" }}>
          <h2
            style={{
              fontSize: "20px",
              fontWeight: "600",
              color: "#2d3748",
              marginBottom: "16px",
              display: "flex",
              alignItems: "center",
              gap: "10px",
            }}
          >
            <FaThumbtack style={{ color: "#667eea" }} />
            Pinned Notices
          </h2>
          {pinnedNotices.map((notice) => (
            <NoticeCard key={notice.id} notice={notice} />
          ))}
        </div>
      )}

      {/* Regular Notices */}
      <div>
        {regularNotices.length > 0 && (
          <h2
            style={{
              fontSize: "20px",
              fontWeight: "600",
              color: "#2d3748",
              marginBottom: "16px",
            }}
          >
            Recent Updates
          </h2>
        )}
        {regularNotices.length > 0 ? (
          regularNotices.map((notice) => <NoticeCard key={notice.id} notice={notice} />)
        ) : pinnedNotices.length === 0 ? (
          <div
            style={{
              padding: "60px",
              textAlign: "center",
              background: "white",
              borderRadius: "12px",
              border: "1px solid #e2e8f0",
            }}
          >
            <FaBullhorn style={{ fontSize: "48px", color: "#cbd5e0", marginBottom: "16px" }} />
            <p style={{ color: "#718096", fontSize: "16px" }}>
              No notices found in this category
            </p>
          </div>
        ) : null}
      </div>
    </div>
  );
}

